module.exports = __webpack_public_path__ + "img/binocular.c1964af4.svg";